import ReactGA from "react-ga4";

export const initGA = (trackingID) => {
  //console.log("TRCKING ID-----------"+trackingID)
  ReactGA.initialize(trackingID);
};

export const logPageView = () => {
 // debugger;
  const pagePath = window.location.pathname + window.location.search; 
  //console.log("Logging page view for:", pagePath);
  // ReactGA.set({ page: window.location.pathname });
  // ReactGA.pageview(window.location.pathname);
  ReactGA.send({ hitType: "pageview", page: pagePath });
};

export const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleDateString();
};
